import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useContext } from "react";
import { ShopContext } from "../../Context/ShopContext";
import Item from "../Item/Item";
import "./Accessories.css";
 
const Accessories = () => {
  const { all_product } = useContext(ShopContext);
  const trackRef = useRef();
 
  const accessories = all_product
    .filter((p) => p.category === "accessories")
    .slice(5, 15)
    .reverse();
    
 
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
 
    let isDown = false;
    let startX;
    let scrollLeft;
    let hasDragged = false;
 
    const onDown = (e) => {
      isDown = true;
      hasDragged = false;
      track.classList.add("dragging");
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    };
    const onLeave = () => { isDown = false; track.classList.remove("dragging"); };
    const onUp = () => { isDown = false; track.classList.remove("dragging"); };
    const onMove = (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - track.offsetLeft;
      const walk = (x - startX) * 1.5;
      if (Math.abs(walk) > 5) hasDragged = true;
      track.scrollLeft = scrollLeft - walk;
    };
    const onClickCapture = (e) => {
      if (hasDragged) {
        e.stopPropagation();
        e.preventDefault();
        hasDragged = false;
      }
    };
 
    track.addEventListener("mousedown", onDown);
    track.addEventListener("mouseleave", onLeave);
    track.addEventListener("mouseup", onUp);
    track.addEventListener("mousemove", onMove);
    track.addEventListener("click", onClickCapture, true);
 
    return () => {
      track.removeEventListener("mousedown", onDown);
      track.removeEventListener("mouseleave", onLeave);
      track.removeEventListener("mouseup", onUp);
      track.removeEventListener("mousemove", onMove);
      track.removeEventListener("click", onClickCapture, true);
    };
  }, [accessories.length]);
 
  if (accessories.length === 0) return null;
 
  return (
    <div className="accessories">
      <div className="accessories-header">
        <div>
          <h2>Accessories</h2>
          <p>"Elevate your style with handmade extras"</p>
        </div>
        <Link to="/accessories" className="accessories-viewall">View All →</Link>
      </div>
      <div className="showcase-track" ref={trackRef}>
        {accessories.map((item) => (
          <div className="showcase-item" key={item.id}>
            <Item
              id={item.id}
              name={item.name}
              size={item.size}
              color={item.color}
              image={item.image_urls[0]}
              new_price={item.new_price}
              soldOut={item.soldOut}
              madeToOrder={item.madeToOrder}
              fileType={item.fileType}
              quantity={item.quantity}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
 
export default Accessories;